var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    id: "VRSculpting",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    viewBox: "0 0 925.94 2"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 925.94,
    y1: 1,
    y2: 1,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStroke001a57 svgStroke"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "a",
    viewBox: "0 0 1080 1080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    fill: "#f0f4f8",
    className: "colorb2f2ff svgShape"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    viewBox: "0 0 178.09 163.69"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    d: "m28.98,11.94h13c3.39,0,6.15,2.75,6.15,6.15v19.14h-25.29v-19.14c0-3.39,2.75-6.15,6.15-6.15Z",
    className: "color752adf svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#9c27b0",
    points: "131.73 30.56 59.72 30.56 68.79 0 122.65 0 131.73 30.56",
    className: "color752adf svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 178.09,
    height: 138.05,
    y: 25.64,
    fill: "#0364ed",
    rx: 18.97,
    ry: 18.97,
    className: "color03edc2 svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.05,
    cy: 101.87,
    r: 41.71,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    d: "m89.05,152.65c-28,0-50.79-22.78-50.79-50.79s22.78-50.79,50.79-50.79,50.79,22.78,50.79,50.79-22.78,50.79-50.79,50.79Zm0-83.43c-18,0-32.64,14.64-32.64,32.64s14.64,32.64,32.64,32.64,32.64-14.64,32.64-32.64-14.64-32.64-32.64-32.64Z",
    className: "color752adf svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.1,
    height: 16.51,
    x: 136.29,
    y: 42.5,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "f",
    viewBox: "0 0 120.71 107.32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m66.98,3.7C54.83,2.62,42.68,1.55,30.53.47c-1.77-.16-3.54-.31-5.31-.47-.59-.05-.99.33-1.23.81C17.04,14.72,10.08,28.63,3.12,42.54c-1,1.99-1.99,3.98-2.99,5.97-.7,1.39,1.6,2.18,2.29.8,6.96-13.91,13.92-27.81,20.88-41.72,1-1.99,1.99-3.98,2.99-5.97-.41.27-.82.54-1.23.81,12.15,1.08,24.3,2.15,36.45,3.23,1.77.16,3.54.31,5.31.47,1.56.14,1.72-2.29.16-2.42h0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m.35,49.69c11.66,11.92,23.31,23.84,34.97,35.76,5.48,5.61,10.97,11.22,16.45,16.83,1.01,1.03,1.62,1.33,3.09,1.46,4.14.37,8.29.73,12.43,1.1l27.98,2.48c.38.03.9-.16,1.08-.52,7.04-13.88,14.09-27.75,21.13-41.63,1.01-1.99,2.02-3.97,3.02-5.96.23-.46.33-1.06-.08-1.48-15.38-15.68-30.77-31.35-46.15-47.03-2.15-2.19-4.31-4.39-6.46-6.58-1.09-1.11-2.94.46-1.85,1.58,15.38,15.68,30.77,31.35,46.15,47.03,2.15,2.19,4.31,4.39,6.46,6.58-.03-.49-.05-.99-.08-1.48-7.04,13.88-14.09,27.75-21.13,41.63-1.01,1.99-2.02,3.97-3.02,5.96.36-.17.72-.35,1.08-.52-7.84-.69-15.68-1.39-23.52-2.08-4.83-.43-9.66-.85-14.49-1.28-.91-.08-2.55-.56-3.44-.3-.82.24.86-.79.51.37.01-.05-.34-.34-.38-.39-1.46-1.91-3.49-3.57-5.17-5.28-3.14-3.21-6.28-6.42-9.42-9.63-7.75-7.93-15.51-15.86-23.26-23.79-4.69-4.8-9.38-9.59-14.07-14.39-1.09-1.11-2.94.46-1.85,1.58H.35Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m41.82,53.29c15.38,15.68,30.77,31.35,46.15,47.03,2.15,2.19,4.31,4.39,6.46,6.58,1.09,1.11,2.94-.46,1.85-1.58-15.38-15.68-30.77-31.35-46.15-47.03-2.15-2.19-4.31-4.39-6.46-6.58-1.09-1.11-2.94.46-1.85,1.58h0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m24.68,1.61c12.96,13.2,25.91,26.41,38.87,39.61,3.27,3.33,6.54,6.67,9.81,10,.94.96,1.89,1.92,2.83,2.89.16.17,1.37,1.55,1.07.75-.2-.54.03-.25-.27.13-.31.39-.5.98-.72,1.42-.81,1.6-1.62,3.19-2.43,4.79-2.56,5.04-5.12,10.09-7.68,15.13-4.36,8.58-8.71,17.16-13.07,25.74-.35.69.65,1.38,1,.69,7.04-13.88,14.09-27.75,21.13-41.63,1.01-1.99,2.02-3.97,3.02-5.96.12-.23.17-.53-.04-.74-15.38-15.68-30.77-31.35-46.15-47.03-2.15-2.19-4.31-4.39-6.46-6.58-.55-.56-1.47.23-.92.79h0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "M77.71 55.43c12.15 1.08 24.3 2.15 36.45 3.23 1.77.16 3.54.31 5.31.47.78.07.86-1.14.08-1.21-12.15-1.08-24.3-2.15-36.45-3.23-1.77-.16-3.54-.31-5.31-.47-.78-.07-.86 1.14-.08 1.21h0ZM1.2 50.12c12.1 1.05 24.19 2.1 36.29 3.14 1.73.15 3.45.3 5.18.45.38.03.9-.16 1.08-.52 7.04-13.88 14.09-27.75 21.13-41.63 1.01-1.99 2.02-3.97 3.02-5.96.7-1.37-1.29-2.77-2-1.38-7.04 13.88-14.09 27.75-21.13 41.63-1.01 1.99-2.02 3.97-3.02 5.96.36-.17.72-.35 1.08-.52-12.1-1.05-24.19-2.1-36.29-3.14-1.73-.15-3.45-.3-5.18-.45-1.56-.13-1.72 2.29-.16 2.42h0Z",
    className: "color004feb svgShape"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "g",
    viewBox: "0 0 72.08 64.54"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m57.17,62.85c-10.47-2.28-20.94-4.56-31.42-6.85-1.51-.33-3.02-.66-4.52-.99.2.35.4.71.6,1.06,4.15-11.47,8.31-22.94,12.46-34.41.59-1.62,1.17-3.24,1.76-4.86l-1.06.6c10.47,2.28,20.94,4.56,31.42,6.85,1.51.33,3.02.66,4.52.99-.2-.35-.4-.71-.6-1.06-4.15,11.47-8.31,22.94-12.46,34.41-.59,1.62-1.17,3.24-1.76,4.86-.38,1.05,1.29,1.5,1.67.46,4.15-11.47,8.31-22.94,12.46-34.41.59-1.62,1.17-3.24,1.76-4.86.15-.42-.17-.97-.6-1.06-10.47-2.28-20.94-4.56-31.42-6.85-1.51-.33-3.02-.66-4.52-.99-.48-.11-.9.14-1.06.6-4.15,11.47-8.31,22.94-12.46,34.41l-1.76,4.86c-.15.42.17.97.6,1.06,10.47,2.28,20.94,4.56,31.42,6.85,1.51.33,3.02.66,4.52.99,1.08.24,1.55-1.43.46-1.67Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m71.78,23.81c-3.13-2.45-6.26-4.89-9.39-7.34-2.3-1.8-4.61-3.6-6.91-5.4-1.23-.96-2.43-2.07-3.74-2.92-.62-.41-1.29-.48-2.02-.64-1.93-.42-3.87-.84-5.8-1.26-5.74-1.25-11.48-2.5-17.23-3.75C22.9,1.67,19.11.84,15.32.02c-.76-.17-1.58.87-.84,1.45,6.71,5.25,13.42,10.49,20.13,15.74.87.68,2.1-.54,1.22-1.22C29.12,10.73,22.41,5.49,15.7.24c-.28.48-.56.96-.84,1.45,8.76,1.91,17.51,3.82,26.27,5.72,3.2.7,6.42,1.56,9.65,2.1-.04,0-.54-.35-.25-.13.18.14.36.28.54.42.65.51,1.3,1.02,1.95,1.52,2.13,1.66,4.25,3.32,6.38,4.98,3.72,2.91,7.43,5.81,11.15,8.72.87.68,2.1-.54,1.22-1.22h0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "M14.26.62C10.1 12.09 5.95 23.56 1.79 35.03c-.59 1.62-1.17 3.24-1.76 4.86-.09.26 0 .67.22.84 6.71 5.25 13.42 10.49 20.13 15.74.87.68 2.1-.54 1.22-1.22-6.71-5.25-13.42-10.49-20.13-15.74.07.28.15.56.22.84C5.86 28.87 10.01 17.41 14.17 5.94c.59-1.62 1.17-3.24 1.76-4.86.38-1.05-1.29-1.5-1.67-.46h0ZM57.25 63.38c-3.49-2.73-6.98-5.46-10.47-8.19l-6.96-5.44c-.7-.55-1.4-1.09-2.1-1.64-.16-.12-.33-.3-.51-.4-.26-.14 0 .37.03.29 1.51-3.24 2.49-6.86 3.7-10.22 2.15-5.95 4.31-11.89 6.46-17.84 1.35-3.72 2.69-7.43 4.04-11.15.19-.52-.65-.75-.83-.23-4.15 11.47-8.31 22.94-12.46 34.41-.59 1.62-1.17 3.24-1.76 4.86-.05.13 0 .33.11.42 6.71 5.25 13.42 10.49 20.13 15.74.43.34 1.05-.27.61-.61h0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m36.93,47.53c-10.47-2.28-20.94-4.56-31.42-6.85-1.51-.33-3.02-.66-4.52-.99-.54-.12-.77.72-.23.83,10.47,2.28,20.94,4.56,31.42,6.85,1.51.33,3.02.66,4.52.99.54.12.77-.72.23-.83h0Z",
    className: "color004feb svgShape"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "h",
    viewBox: "0 0 105.27 105.15"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m88.41,76.8c4.9-11.47,9.79-22.93,14.69-34.4.69-1.62,1.38-3.23,2.07-4.85.13-.31.14-.65-.12-.91-4.1-4.09-8.19-8.18-12.29-12.28-6.54-6.53-13.08-13.07-19.62-19.6-1.52-1.52-3.04-3.03-4.55-4.55-.26-.26-.6-.25-.91-.12-11.48,4.89-22.96,9.78-34.44,14.67-1.62.69-3.24,1.38-4.85,2.07-.89.38-.12,1.67.76,1.3,11.48-4.89,22.96-9.78,34.44-14.67,1.62-.69,3.24-1.38,4.85-2.07-.3-.04-.61-.08-.91-.12,4.1,4.09,8.19,8.18,12.29,12.28,6.54,6.53,13.08,13.07,19.62,19.6,1.52,1.52,3.04,3.03,4.55,4.55-.04-.3-.08-.61-.12-.91-4.9,11.47-9.79,22.93-14.69,34.4l-2.07,4.85c-.37.88.92,1.64,1.3.76h0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m28.4,17.59c3.56,13.67,7.12,27.35,10.69,41.02.5,1.92,1,3.83,1.5,5.75.03.12.14.23.26.26,13.69,3.56,27.38,7.11,41.07,10.67,1.92.5,3.84,1,5.75,1.5.47.12.67-.6.2-.72-13.69-3.56-27.38-7.12-41.07-10.67-1.84-.48-3.78-1.21-5.67-1.47-.22-.03.19.38.15.16-.03-.22-.11-.44-.17-.65-.26-1-.52-2-.78-3-2.08-7.99-4.16-15.98-6.24-23.97-1.65-6.35-3.31-12.71-4.96-19.06-.12-.47-.85-.27-.72.2h0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "M60.43 104.76c4.9-11.47 9.79-22.93 14.69-34.4.69-1.62 1.38-3.23 2.07-4.85.13-.31.14-.65-.12-.91-4.1-4.09-8.19-8.18-12.29-12.28-6.54-6.53-13.08-13.07-19.62-19.6-1.52-1.52-3.04-3.03-4.55-4.55-.68-.68-1.74.38-1.06 1.06 4.1 4.09 8.19 8.18 12.29 12.28 6.54 6.53 13.08 13.07 19.62 19.6 1.52 1.52 3.04 3.03 4.55 4.55-.04-.3-.08-.61-.12-.91-4.9 11.47-9.79 22.93-14.69 34.4l-2.07 4.85c-.37.88.92 1.64 1.3.76h0ZM13.22 92.48c8.15-8.14 16.3-16.28 24.46-24.43 1.18-1.18 2.35-2.35 3.53-3.53.34-.34-.19-.87-.53-.53-8.15 8.14-16.3 16.28-24.46 24.43-1.18 1.18-2.35 2.35-3.53 3.53-.34.34.19.87.53.53h0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "M77.07 65.66c8.15-8.14 16.3-16.28 24.46-24.43 1.18-1.18 2.35-2.35 3.53-3.53.68-.68-.38-1.74-1.06-1.06-8.15 8.14-16.3 16.28-24.46 24.43-1.18 1.18-2.35 2.35-3.53 3.53-.68.68.38 1.74 1.06 1.06h0ZM60.31 104.91c8.15-8.14 16.3-16.28 24.46-24.43 1.18-1.18 2.35-2.35 3.53-3.53.68-.68-.38-1.74-1.06-1.06-8.15 8.14-16.3 16.28-24.46 24.43-1.18 1.18-2.35 2.35-3.53 3.53-.68.68.38 1.74 1.06 1.06h0ZM67.68.1c-11.09 4.72-22.17 9.44-33.26 14.17-1.88.8-3.81 1.53-5.65 2.41-.79.38-1.34 1.08-1.96 1.7-4.76 4.75-9.51 9.5-14.27 14.25-4.1 4.1-8.2 8.19-12.3 12.29-.68.68.38 1.74 1.06 1.06 8.45-8.44 16.9-16.88 25.36-25.33.67-.67 1.34-1.34 2.01-2.01.15-.15.82-.7.5-.51 1.3-.76 2.89-1.23 4.27-1.82 6.66-2.84 13.33-5.68 19.99-8.51 5-2.13 10-4.26 15-6.39.89-.38.12-1.67-.76-1.3h0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m59.98,103.66c-13.69-3.56-27.38-7.11-41.07-10.67-1.92-.5-3.84-1-5.75-1.5.17.17.35.35.52.52-3.56-13.67-7.12-27.35-10.69-41.02-.5-1.92-1-3.83-1.5-5.75-.24-.93-1.69-.54-1.45.4,3.56,13.67,7.12,27.35,10.69,41.02.5,1.92,1,3.83,1.5,5.75.06.25.27.46.52.52,13.69,3.56,27.38,7.12,41.07,10.67,1.92.5,3.84,1,5.75,1.5.94.24,1.33-1.2.4-1.45h0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m1.15,46.09c11.09-4.72,22.17-9.44,33.26-14.17,1.88-.8,3.81-1.53,5.65-2.41.79-.38,1.34-1.08,1.96-1.7,4.76-4.75,9.51-9.5,14.27-14.25,4.1-4.1,8.2-8.19,12.3-12.29.68-.68-.38-1.74-1.06-1.06-8.45,8.44-16.9,16.88-25.36,25.33-.67.67-1.34,1.34-2.01,2.01-.15.15-.82.7-.5.51-1.3.76-2.89,1.23-4.27,1.82-6.66,2.84-13.33,5.68-19.99,8.51-5,2.13-10,4.26-15,6.39-.89.38-.12,1.67.76,1.3h0Z",
    className: "color004feb svgShape"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 454.39 645.3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m271.77,229.34c-.35,38.85-2.84,77.88-9.32,116.22-2.47,14.59-5.51,29.14-9.77,43.32-3.01,10-6.55,20.11-12.04,29.04-1.91,3.11-3.76,5.69-6.5,8.16-1.9,1.71-3.77,2.85-6.4,3.37-.61.12.57-.05-.05.01-.12.01-.24.03-.36.03-.3.01-.6.03-.9.03s-.6-.02-.9-.05c-.6-.04.42.07.04.01-.21-.03-.42-.06-.62-.11-1.64-.39-1.77-.43-3.08-1.18-2.32-1.31-4.64-3.67-6.32-5.88-5.72-7.55-9.22-16.79-12.14-25.72-4.33-13.22-7.3-26.88-9.71-40.56-6.48-36.84-8.81-74.45-9.13-111.82-.35-39.92,1.64-80.05,7.39-119.58,2.26-15.54,5.1-31.03,9.07-46.24,2.91-11.16,6.34-22.37,11.51-32.71,1.77-3.54,4.02-7.44,6.3-10.28,2.08-2.59,4.07-4.56,6.66-5.93,1.76-.93,4.2-1.38,5.89-.98.6.14,1.18.31,1.76.52s-.34-.16.02,0c.15.06.29.13.44.2.35.18.7.36,1.04.55,1.48.87,1.85,1.19,3.07,2.35,5.8,5.51,9.5,13.72,12.44,21.33,4.66,12.05,7.8,24.68,10.38,37.31,7.22,35.3,10.02,71.55,10.96,107.52.27,10.35.35,20.7.27,31.05-.03,3.22,4.97,3.22,5,0,.33-39.9-1.65-80.02-7.77-119.49-2.29-14.79-5.18-29.55-9.4-43.92-2.99-10.18-6.57-20.6-12.26-29.63-3.45-5.48-8.38-11.55-15.16-12.72s-12.33,2.85-16.39,7.69c-6.25,7.46-10.17,16.75-13.46,25.81-4.81,13.25-8.13,27.02-10.87,40.83-7.5,37.79-10.63,76.49-11.63,114.95-1.06,40.77.34,81.79,5.66,122.25,2.08,15.83,4.73,31.62,8.6,47.11,2.87,11.45,6.33,22.95,11.64,33.54,3.22,6.43,7.6,13.8,14.3,17.13,5.96,2.97,12.1,1.39,17.04-2.76,6.54-5.49,10.6-13.89,13.88-21.59,5.11-12.02,8.63-24.69,11.54-37.41,8.24-36.01,11.81-73.16,13.44-110,.47-10.59.74-21.2.84-31.8.03-3.22-4.97-3.22-5,0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m86.16,227.71c.39-40.19,8.86-80.78,27.26-116.68,15.17-29.61,37.66-56.88,67.72-72.17,27.31-13.89,59.15-15.48,87.53-3.78,30.61,12.62,54.2,38.31,70.29,66.65,19.52,34.38,29.25,73.98,30.95,113.31,1.76,40.63-4.78,82.12-21.15,119.48-13.65,31.17-34.6,60.54-63.73,78.91-25.92,16.35-57.36,21.87-86.95,13.07-31.19-9.28-56.32-32.48-73.91-59.22-21.27-32.34-32.91-70.62-36.66-108.96-.99-10.17-1.43-20.39-1.35-30.6.01-1.61-2.49-1.61-2.5,0-.16,21.2,1.92,42.43,6.48,63.15,4.21,19.16,10.56,37.89,19.23,55.5,7.84,15.93,17.65,30.97,29.6,44.14,10.84,11.96,23.54,22.39,37.85,29.94s28.63,11.66,44.02,12.63c15.35.97,30.84-1.58,45.15-7.19,14.75-5.78,28.15-14.59,39.85-25.24,12.9-11.74,23.74-25.67,32.66-40.62,9.78-16.41,17.3-34.15,22.77-52.44,5.96-19.93,9.5-40.57,10.83-61.32,1.38-21.56.37-43.29-3.1-64.62-3.22-19.77-8.6-39.2-16.36-57.68-7.02-16.71-15.98-32.62-27.14-46.93-10.2-13.08-22.3-24.79-36.22-33.86-12.91-8.42-27.43-14.48-42.66-17.07s-30.75-1.78-45.56,2.32-29.14,11.67-41.52,21.23c-13.42,10.37-24.89,23.09-34.52,37.02-10.62,15.37-18.98,32.24-25.36,49.77-7.02,19.27-11.6,39.38-14.01,59.73-1.24,10.46-1.89,20.99-1.99,31.53-.02,1.61,2.48,1.61,2.5,0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m228.62,177.02c39.13.36,78.47,3.23,116.94,10.65,14.65,2.83,29.23,6.32,43.36,11.17,10.32,3.55,20.73,7.79,29.69,14.14,5.29,3.75,11.08,8.99,12.03,15.79.9,6.42-3.29,11.95-7.85,15.94-7.37,6.45-16.76,10.62-25.82,14.06-13.2,5-26.96,8.48-40.77,11.29-37.06,7.55-75.11,10.35-112.87,10.77-40.08.45-80.4-1.84-119.97-8.39-15.69-2.6-31.31-5.87-46.56-10.42-11.36-3.39-22.73-7.44-33.06-13.34-6.49-3.71-13.7-8.57-16.86-15.65-2.5-5.6-.89-11.42,2.89-16.01,5.59-6.79,13.93-11.16,21.81-14.71,12.01-5.41,24.81-9.08,37.6-12.1,35.49-8.39,72.21-11.73,108.59-12.86,10.29-.32,20.59-.42,30.88-.34,1.61.01,1.61-2.49,0-2.5-39.85-.32-79.98,1.98-119.26,8.99-14.96,2.67-29.87,6.04-44.28,10.9-10.28,3.47-20.73,7.64-29.58,14.04-5.55,4.01-11.2,9.46-12.24,16.57s2.73,12.83,7.44,17.35c7.15,6.85,16.44,11.35,25.49,15.1,13.17,5.46,27.01,9.29,40.89,12.43,37.53,8.49,76.23,12.06,114.64,13.17,40.84,1.18,81.97-.51,122.41-6.59,15.97-2.4,31.89-5.51,47.42-9.99,11.5-3.32,23.07-7.33,33.48-13.33,6.57-3.79,13.63-8.8,16.77-15.97,2.64-6.02,1.31-12.39-2.53-17.56-5.3-7.13-13.5-11.91-21.35-15.73-11.86-5.78-24.56-9.81-37.3-13.14-35.94-9.41-73.34-13.5-110.37-15.33-10.53-.52-21.08-.81-31.63-.91-1.61-.01-1.61,2.49,0,2.5Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m429.5,230.69c-.21,21.03-3.65,41.93-10.33,61.89s-15.88,37.44-27.78,53.87c-11.75,16.22-26.03,30.73-42.05,42.74-16.3,12.21-34.42,22-53.62,28.79-19.77,6.99-40.57,10.87-61.52,11.47-21.21.61-42.44-2.06-62.81-8.01-19.58-5.72-38.22-14.45-55.19-25.77-16.73-11.16-31.74-24.86-44.46-40.43-12.73-15.59-23.14-33.21-30.61-51.91s-12.41-39.75-13.82-60.46.41-42.52,5.62-63.1c5.03-19.88,13.14-38.91,23.96-56.33s23.81-32.52,38.98-45.73,32.49-24.18,50.97-32.35c18.89-8.35,39.19-13.74,59.74-15.9,21.21-2.22,42.78-1.18,63.65,3.26s39.47,11.6,57.34,21.73,33.52,22.49,47.35,37.15c13.83,14.66,25.42,31.38,34.3,49.47,9.07,18.46,15.19,38.35,18.2,58.69,1.51,10.23,2.16,20.58,2.09,30.92-.02,3.22,4.98,3.22,5,0,.15-21.54-3-43.11-9.51-63.65s-15.61-38.7-27.57-55.71c-11.81-16.8-26.06-31.83-42.28-44.43-16.48-12.8-34.77-23.08-54.31-30.42-20.11-7.57-41.41-11.88-62.87-12.89s-43.59,1.35-64.55,7.08-39.49,14.14-57.05,25.46c-17.33,11.17-33.01,24.92-46.28,40.7s-24.2,33.56-32.23,52.61-13.41,40.55-15.25,61.81-.29,43.63,4.68,64.79c4.78,20.35,12.76,39.98,23.48,57.93s23.84,33.81,39.17,47.59c15.34,13.79,32.72,25.3,51.46,33.94,19.37,8.94,40,14.79,61.17,17.44s43.84,1.94,65.32-2.21c20.66-3.99,40.7-11.23,59.18-21.29,18.13-9.87,34.78-22.51,49.19-37.29,14.35-14.73,26.52-31.62,35.87-49.93s16.29-39.04,19.68-59.87c1.7-10.47,2.61-21.05,2.72-31.66.03-3.22-4.97-3.22-5,0Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 163.34,
    height: 150.34,
    x: 143.01,
    y: 473.88,
    fill: "#2b2b2b",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#006aff",
    points: "306.35 473.88 143.01 473.88 133.94 455.62 315.43 455.62 306.35 473.88",
    className: "color00a9ff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m243.62,513.05h32.32c8.53,0,15.46,6.93,15.46,15.46v101.16h-63.23v-101.16c0-8.53,6.93-15.46,15.46-15.46Z",
    className: "colorStrokeffffff svgStroke"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 203.74,
    height: 21.08,
    x: 122.82,
    y: 624.23,
    fill: "#006aff",
    className: "color00a9ff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.48,
    height: 33.02,
    x: 267.86,
    y: 557.14,
    fill: "#0364ed",
    className: "color03edc2 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.83,
    height: 5.97,
    x: 156.34,
    y: 503.74,
    fill: "#0364ed",
    className: "color03edc2 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.83,
    height: 5.97,
    x: 156.34,
    y: 514.81,
    fill: "#0364ed",
    className: "color03edc2 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.83,
    height: 5.97,
    x: 156.34,
    y: 525.87,
    fill: "#0364ed",
    className: "color03edc2 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.83,
    height: 5.97,
    x: 156.34,
    y: 536.94,
    fill: "#0364ed",
    className: "color03edc2 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.83,
    height: 5.97,
    x: 156.34,
    y: 548,
    fill: "#0364ed",
    className: "color03edc2 svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.83,
    height: 5.97,
    x: 156.34,
    y: 559.07,
    fill: "#0364ed",
    className: "color03edc2 svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.34,
    cy: 227.19,
    r: 24.34,
    fill: "#3c9dff",
    className: "colorffc33c svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430.05,
    cy: 227.19,
    r: 24.34,
    fill: "#3c9dff",
    className: "colorffc33c svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.19,
    cy: 24.34,
    r: 24.34,
    fill: "#3c9dff",
    className: "colorffc33c svgShape"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    viewBox: "0 0 534.73 682.27"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 438.38,
    cy: 448.12,
    r: 22.26,
    fill: "#0047ab",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m480.09,435.87l-3.66,2.51-23.88,19.41c-7.52,4.38-17.26,1.81-21.64-5.71l-2.39-4.11c-4.38-7.52-1.81-17.26,5.71-21.64l14.89-4.62,8.23-13.25c3.1,1.74,2.78,10.28,7.16,17.81l2.97,7.39c4.38,7.52,20.12-2.15,12.6,2.23Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.79,
    cy: 39.66,
    r: 22.4,
    fill: "#0047ab",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "m45.48,60.06l-5.35-17.53c-1.29-8.45,4.57-16.43,13.03-17.72l4.62-.7c8.45-1.29,16.43,4.57,17.72,13.03,0,0-14,10.04-5.75,24.93s6.99,22.27,6.99,22.27c-1.56,1.41-2.8,10.95-7.56,16.7l-4.98-12.76c-8.26-19.11-15.87-22.24-18.71-28.21Z",
    className: "color004feb svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m257.79,111.47c-17.4,13.66-34.81,27.32-52.21,40.98s-34.81,27.32-52.21,40.98c-9.81,7.7-19.63,15.41-29.44,23.11-.8.63-.65,1.99,0,2.65.78.8,1.86.62,2.65,0,17.4-13.66,34.81-27.32,52.21-40.98,17.4-13.66,34.81-27.32,52.21-40.98,9.81-7.7,19.63-15.41,29.44-23.11.8-.63.65-1.99,0-2.65-.78-.8-1.86-.62-2.65,0h0Z",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m143.39,203.13c-9.11-12.82-18.22-25.64-27.33-38.45-4.56-6.41-9.12-12.83-13.67-19.24-4.16-5.86-8.79-11.39-12.7-17.43-.83-1.28-1.73-2.45-1.76-4.03-.03-1.75.53-3.46.88-5.16.76-3.64,1.63-7.26,2.7-10.82,2.14-7.09,5.09-13.97,6.36-21.3,1.13-6.57.74-13.17-2.17-19.24-2.51-5.24-6.73-9.74-11.81-12.57-3.06-1.7-6.96-3.31-10.49-2.19s-5.29,4.46-5.53,7.88c-.27,3.86,1.3,7.94,3.06,11.31s4.03,6.24,6.77,8.7l-.29-2.27c-3.5,7.74-7,15.47-10.51,23.21-.42.93-.26,2.01.67,2.57.8.48,2.15.25,2.57-.67,3.5-7.74,7-15.47,10.51-23.21.33-.73.36-1.68-.29-2.27-2.32-2.09-4.28-4.49-5.8-7.23s-2.75-5.72-2.93-8.74c-.17-2.78,1.05-5.89,4.26-5.89,2.71,0,5.48,1.54,7.69,2.98,4.5,2.94,8.06,7.46,9.82,12.54,2.16,6.2,1.43,12.76-.24,18.99-1.81,6.8-4.51,13.32-6.32,20.12-.87,3.27-1.6,6.59-2.26,9.91-.31,1.53-.51,3.07-.28,4.63s1.05,2.91,1.91,4.25c3.69,5.77,8.12,11.03,12.09,16.61,4.28,6,8.54,12.02,12.81,18.03,9.68,13.62,19.36,27.24,29.04,40.87,1.39,1.95,4.64.08,3.24-1.89h0Z",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m71.15,98.62c-5.53-13.19-13.12-25.7-21.31-37.39-3.4-4.85-8.36-9.55-14.8-8.02-2.91.69-5.2,2.89-5.97,5.79-.81,3.06-.02,6.32.92,9.25,2.54,7.87,5.73,15.55,9.4,22.95,1.07,2.16,4.31.26,3.24-1.89-2.94-5.94-5.54-12.04-7.74-18.29-1.29-3.66-5.07-12.01.52-14.01,5.23-1.87,9.34,3.36,11.88,7.1,3.56,5.26,6.99,10.62,10.23,16.08,3.71,6.26,7.21,12.7,10.02,19.43.39.93,1.24,1.61,2.31,1.31.88-.25,1.7-1.36,1.31-2.31h0Z",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m32.96,67.15c-2.11-3.05-6.21-3.82-9.42-2.02-3.53,1.97-4.96,6.08-5.13,9.91-.2,4.32.57,8.83,1.54,13.02s2.49,8.51,4.35,12.53c1.01,2.19,4.24.29,3.24-1.89-2.89-6.26-4.71-13.06-5.27-19.94-.24-3.02-.39-6.53,1.61-9.05,1.31-1.64,4.36-2.8,5.84-.66,1.37,1.97,4.62.1,3.24-1.89h0Z",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m20.57,81.47c-3.24-.79-6.53.32-8.92,2.59-2.56,2.42-3.63,5.94-3.96,9.36-.75,7.77,2.21,15.39,4.98,22.48.37.94,1.26,1.6,2.31,1.31.9-.25,1.68-1.35,1.31-2.31-2.37-6.07-4.88-12.36-4.95-18.97-.03-2.76.35-5.66,1.92-7.99,1.36-2.02,3.85-3.44,6.31-2.85s3.34-3.05,1-3.62h0Z",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m8.31,99.41C2.23,103.85-.39,111.39.05,118.75c.51,8.75,5.12,16.56,9.81,23.71,10.6,16.15,21.68,32,33.07,47.6,11.41,15.62,23.17,30.98,35.29,46.06,6.04,7.51,12.16,14.95,18.38,22.32,5.29,6.27,10.73,12.51,17.12,17.71s13.23,9.07,21.12,10.54c8.81,1.64,17.82.13,26.12-3.05,11.22-4.31,21.12-11.16,30.57-18.45,8.81-6.79,17.37-13.89,25.85-21.08,9.91-8.4,19.7-16.96,29.4-25.61,9.44-8.42,18.8-16.94,28.04-25.58,7.17-6.71,14.3-13.47,21.17-20.49,1.19-1.22,2.38-2.45,3.54-3.7,1.65-1.76-1-4.42-2.65-2.65-5.79,6.2-11.93,12.09-18.08,17.93-8.56,8.14-17.25,16.14-26.01,24.06-9.55,8.63-19.2,17.17-28.95,25.58-8.81,7.6-17.69,15.12-26.76,22.41-6.85,5.51-13.78,11.01-21.22,15.72-14.23,9.01-31.95,16.12-48.41,8.67-7.18-3.25-13.25-8.4-18.7-14.01-5.99-6.16-11.4-12.88-16.88-19.5-12.06-14.59-23.8-29.45-35.17-44.58-11.36-15.11-22.38-30.47-33.04-46.08-5.16-7.56-10.67-15.07-15.08-23.1-3.77-6.87-6.26-14.76-3.86-22.52.97-3.15,2.79-6.07,5.48-8.03,1.93-1.41.06-4.67-1.89-3.24h0Z",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M229.28 136.94c10.17 14.83 20.35 29.66 30.52 44.49 2.92 4.26 5.84 8.51 8.76 12.77 1.36 1.98 4.61.1 3.24-1.89-10.17-14.83-20.35-29.66-30.52-44.49l-8.76-12.77c-1.36-1.98-4.61-.1-3.24 1.89h0ZM350.97 236.96c11.62 15.26 23.23 30.52 34.85 45.78 5.62 7.38 11.24 14.75 16.85 22.14 5.28 6.96 10.52 13.96 15.22 21.33 9.26 14.53 16.71 31.23 16.37 48.8-.09 4.58-.86 9.1-1.38 13.64s-2.08 8.28-3.84 12.32c-2.78 6.37-5.37 13.98-2.01 20.66 3.79 7.52 13.81 8.31 20.29 3.98 7.78-5.2 10.25-14.56 12.19-23.16l-3.68-.5c.31 10.79 3.27 21.58 8.87 30.84 2.2 3.65 5.59 7.69 10.26 7.66 3.81-.03 7.79-2.88 7.57-6.98l-2.82 1.62c4.86 2.88 11.23 3.01 16.06-.03 4.67-2.94 7.43-8.39 7.15-13.88-.94.54-1.88 1.08-2.82 1.62 7.64 4.65 17.12-.48 17.9-9.22l-2.37 1.81c4.96 2 10.95.89 14.87-2.75s4.76-8.98 3.93-14.11c-.87-5.37-3.06-10.58-4.76-15.72-2.21-6.67-4.56-13.3-7.04-19.87-9.3-24.59-20.44-48.47-32.94-71.59-12.48-23.09-26.31-45.43-41.08-67.11-15.18-22.29-31.28-43.97-49.01-64.3-16.03-18.37-34.36-35.03-55.96-46.6-2.6-1.39-5.23-2.7-7.91-3.93-2.18-1-4.08 2.23-1.89 3.24 21.52 9.93 40.13 25.03 56.22 42.28 17.73 19 33.48 39.9 48.37 61.16 14.54 20.75 28.25 42.09 40.78 64.11 12.54 22.04 23.92 44.77 33.63 68.19 5.11 12.33 9.77 24.84 13.9 37.53 2.55 7.82 9.25 22.47-2.63 26.19-2.51.79-5.06.64-7.49-.35-1.23-.5-2.28.73-2.37 1.81-.54 6.03-7.23 9.05-12.26 5.99-1.17-.71-2.89.2-2.82 1.62.21 4.18-1.7 8.38-5.3 10.64-3.73 2.35-8.52 2.26-12.28.03-1.18-.7-2.9.18-2.82 1.62.17 3.21-4.08 3.73-6.24 2.52-3.29-1.84-5.19-5.89-6.8-9.12-3.85-7.74-5.91-16.3-6.16-24.93-.06-2.05-3.2-2.63-3.68-.5-1.67 7.39-3.54 15.9-10.06 20.63-5.4 3.92-14.14 3.29-16.18-3.99-2-7.13 2.36-14.1 4.85-20.48 1.54-3.94 1.96-7.89 2.5-12.05s1.1-8.64.98-13c-.45-16.8-7.15-32.65-15.92-46.73-9.13-14.66-20.19-28.13-30.64-41.86-12.41-16.3-24.82-32.6-37.22-48.9-1.44-1.9-4.7-.03-3.24 1.89h0Z",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m414.32,181.35c-15.41,15-30.47,30.37-45.15,46.08-4.2,4.49-8.36,9.01-12.5,13.55-1.62,1.78,1.02,4.44,2.65,2.65,14.47-15.91,29.32-31.48,44.52-46.69,4.34-4.35,8.72-8.66,13.12-12.95,1.73-1.69-.92-4.34-2.65-2.65h0Z",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 314.71,
    x2: 403.11,
    y1: 315.86,
    y2: 663.37,
    fill: "none",
    stroke: "#2b2b2b",
    strokeLinejoin: "round",
    strokeWidth: 100,
    className: "colorStroke001a57 svgStroke"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.04,
    x2: 234,
    y1: 324.92,
    y2: 659.1,
    fill: "none",
    stroke: "#2b2b2b",
    strokeLinejoin: "round",
    strokeWidth: 100,
    className: "colorStroke001a57 svgStroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3c9dff",
    d: "m321.74,251.09h-42.2c-30.75,0-53.51-28.61-46.59-58.57l15.43-66.8c5.01-21.69,24.33-37.06,46.59-37.06h11.35c22.26,0,41.58,15.36,46.59,37.06l15.43,66.8c6.92,29.96-15.84,58.57-46.59,58.57Z",
    className: "colorffc33c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#db48f4",
    d: "M263.67 245.34c-2.07-5.97-4.04-11.97-6.07-17.96-4.04-11.98-8.09-23.97-12.13-35.95-1.91-5.66-3.59-11.47-5.91-16.98-.49-1.16-1.03-2.31-1.65-3.42l-2.29 9.93c.19.55.37 1.11.55 1.65 4.02 11.9 8.04 23.81 12.05 35.71 2 5.91 3.99 11.83 5.99 17.74 1.01 3 2.02 5.99 3.03 8.99.07.21.15.43.22.64 2.4 1.25 4.93 2.31 7.56 3.15-.52-1.17-.97-2.37-1.36-3.51ZM326.81 250.27c-.44-.56-1.14-1.73-1.59-2.6-1.01-1.95-1.68-4-2.35-6.22-1.6-5.28-2.98-10.63-4.18-16.01-2.44-10.89-4.18-21.92-5.74-32.96-3.11-22-5.46-44.21-11.15-65.74-2.83-10.72-6.47-21.36-11.44-31.28-1.07-2.13-2.46-4.26-4.2-5.96-6.53 1.22-12.64 3.78-17.99 7.41-.85 5.29-.75 10.83-.7 16.15.06 5.87.4 11.73.93 17.57 1.08 11.94 2.93 23.8 4.89 35.63 3.86 23.31 8.21 46.76 7.52 70.5-.14 4.99-.12 9.55-1.72 14.13-.02.07-.06.14-.08.2.18 0 .37.02.55.02h5.71c.95-3.45 1.21-7.06 1.4-10.65.3-5.78.28-11.57.03-17.35-.52-11.79-2.02-23.52-3.81-35.18-3.54-23.11-8.39-46.12-9.28-69.55-.22-5.79-.19-11.58.15-17.36.13-2.21.25-3.92 1.06-6.13.1-.28.22-.55.52-1.06.27-.46.22-.4.45-.66.64-.72 1.05-1.02 2.05-1.16 1.7-.24 3.65 1.05 4.91 2.51 1.65 1.91 2.67 4.41 3.72 6.68 2.25 4.87 4.19 9.87 5.91 14.96 6.99 20.77 9.99 42.6 12.91 64.24 2.92 21.61 5.54 43.69 12.37 64.49.7 2.12 1.54 4.25 2.62 6.22h1.47c1.87 0 3.72-.11 5.53-.32-.15-.17-.32-.33-.46-.51ZM347.8 243.38c.86-5.46.38-11.43.14-16.69-1.15-25.15-2.29-50.3-3.44-75.45-.57-12.47-1.22-24.95-1.7-37.42-.1-2.63-.17-5.42.1-8.13-1.58-1.88-3.3-3.62-5.14-5.23-1.7 6.84-.91 14.61-.6 21.4 1.16 25.4 2.32 50.8 3.48 76.2.3 6.47.59 12.95.89 19.42.28 6.14.7 12.29.8 18.44.06 3.71-.11 7.92-1.75 11.34 2.54-1.09 4.95-2.39 7.23-3.87Z",
    className: "colorf46648 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m329.62,14.86c5.69,6.76,9.12,15.48,9.12,25,0,12.84-6.23,24.22-15.82,31.29,2.01.45,4.09.69,6.23.69,15.74,0,28.5-12.76,28.5-28.5s-12.5-28.23-28.02-28.48Z",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m266.43,33.5c-1.64,0-3.25-.11-4.83-.31,3.16-18.28,19.09-32.19,38.28-32.19s35.18,13.97,38.3,32.3c-1.29.13-2.59.2-3.91.2-14.57,0-27.26-8.02-33.91-19.89-6.65,11.87-19.34,19.89-33.91,19.89Z",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 299.87,
    cy: 39.86,
    r: 38.86,
    fill: "none",
    stroke: "#2b2b2b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    className: "colorStroke001a57 svgStroke"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 304.4,
    cy: 320.66,
    r: 62.72,
    fill: "#2b2b2b",
    className: "color001a57 svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3c9dff",
    points: "183.75 650.59 283.23 668.1 295.73 595.72 194.36 588.77 183.75 650.59",
    className: "colorffc33c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    d: "m285.74,681.75l.51-31.15h-102.5l-22.95,14.37c-7.17,5.77-3.06,17.35,6.15,17.31l118.78-.52Z",
    className: "color752adf svgShape"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "165.68 657.77 178.41 671.24 190.05 649.75 200.68 667.05 209.51 646.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#3c9dff",
    points: "348.35 650.5 451.74 651.06 437.51 595.7 334.26 595.51 348.35 650.5",
    className: "colorffc33c svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    d: "m451.77,681.75l-.06-31.15h-102.79l-22.95,14.37c-7.17,5.77-3.06,17.35,6.15,17.31l119.66-.52Z",
    className: "color752adf svgShape"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    points: "330.84 657.77 343.57 671.24 355.21 649.75 365.84 667.05 374.67 646.42"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 67.65,
    height: 26.94,
    x: 258.96,
    y: 28.04,
    fill: "#ffffff",
    stroke: "#006aff",
    strokeMiterlimit: 10,
    strokeWidth: 5,
    rx: 9.53,
    ry: 9.53,
    className: "colorffffff svgShape colorStroke00a9ff svgStroke"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0f4f8",
    points: "275.56 52.43 268.85 52.43 280.81 30.49 287.52 30.49 275.56 52.43",
    className: "colorb2f2ff svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f0f4f8",
    points: "305.56 52.43 298.85 52.43 310.81 30.49 317.52 30.49 305.56 52.43",
    className: "colorb2f2ff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.1,
    height: 21.94,
    x: 326.61,
    y: 30.49,
    fill: "#006aff",
    rx: 10.97,
    ry: 10.97,
    className: "color00a9ff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.62,
    height: 12.65,
    x: 332.35,
    y: 35.14,
    fill: "#ffffff",
    rx: 6.32,
    ry: 6.32,
    className: "colorffffff svgShape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: 1080,
    height: 1080,
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 178.09,
    height: 163.69,
    transform: "translate(165.37 420.06)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 454.39,
    height: 645.3,
    transform: "translate(26.76 269.92)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 925.94,
    height: 2,
    transform: "translate(84.92 916.5)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: 534.73,
    height: 682.27,
    transform: "translate(517.5 234.78)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    width: 120.71,
    height: 107.32,
    transform: "translate(352.38 66.69)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    width: 72.08,
    height: 64.54,
    transform: "translate(76.57 149.12)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#040404",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    width: 105.27,
    height: 105.15,
    transform: "translate(442.88 737.59)",
    fill: "#040404",
    className: "color000000 svgShape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/tools.aa8f6866afead7792a2d5024325a39d9.svg";
export { ForwardRef as ReactComponent };